import RunConfigService from './runConfigService';
import util from './nuskin.util';
import axios from 'axios';

/**
 * Utility to build out breadcrumb path on the client. This should only be used if the breadcrumb can't be figured out server side because of performance reasons.
 */

export default {
    getBreadcrumbFromHistory
}

/**
 * Returns the JsonArray for the ns-breadcrumb component based on your previous page and current page.
 * This is mainly used for the Universal Product Detail Page
 * @return {Promise.<Array>}
 */
async function getBreadcrumbFromHistory() {
    let breadcrumbList = [];
    let prevUrl = document.referrer;
    if (prevUrl && prevUrl.includes(RunConfigService.getBaseUrl())) {
        let afterLocaleUrl = prevUrl.replace(RunConfigService.getBaseUrl() + util.getLocaleUrl(), "").replace(".html", "");
        let splitUrl = afterLocaleUrl.split("/");
        splitUrl.forEach(pageName => {
            let pageUrl = _buildSubUrlFromUrl(afterLocaleUrl, pageName);
            breadcrumbList.push({
                href: pageUrl
            });
        });

        await Promise.all(breadcrumbList.map(async page => {
            page.name = await _getPageTitleFromUrl(page.href);
        }));

        breadcrumbList = breadcrumbList.filter(item => {
            return item.name !== "";
        });

        //in the case of the user coming from the login page, show back button on detail page
        if (breadcrumbList[0].name.toLowerCase().includes("http") || document.referrer.includes("content/login/corporate")) {
            breadcrumbList = [];
        }
    }

    breadcrumbList.push({
        href: document.URL,
        name: cleanupURLName(util.getCurrentPageTitle())

    });

    return breadcrumbList;
}

/**
 * Will return page title based on a url
 * @param url
 * @return {Promise.<String>}
 * @private
 */
async function _getPageTitleFromUrl(url) {
    try {
        let urlDocument = await axios.request({
            method: 'get',
            url: url
        });

        let $document = $("<div></div>");
        $document.html(urlDocument.data);

        let $hideInNav = $document.find("meta[name=hide-in-nav]");
        if ($hideInNav.length > 0) {
            return "";
        }

        return $($document.find("title")[0]).text().toString();
    } catch (error) {
        return cleanupURLName(util.getCurrentPageName(url));
    }

}

function cleanupURLName(name) {
    name = name.replace(/(<([^>]+)>)/ig, "").split("  ").join(" ");
    if (name.includes("?")) {
        name = name.split("?")[0];
    }

    return name;
}

/**
 * Will return a complete sub page url
 * @param afterLocaleUrl
 * @param pageName
 * @return {string}
 * @private
 */
function _buildSubUrlFromUrl(afterLocaleUrl, pageName) {
    return RunConfigService.getBaseUrl() + util.getLocaleUrl() + afterLocaleUrl.substring(0, afterLocaleUrl.indexOf(pageName)) + pageName + ".html";
}
